module.exports = __webpack_public_path__ + "static/img/banner6.d0727cc2.png";